import { useSelector } from 'react-redux';

import type { RootState } from 'wanderu-analytics';
import { pricingSelectors } from 'wanderu-ducks-pricing';
import {
    filterSelectors,
    serializeFilterParams,
} from 'wanderu-ducks-search';

import type {
    ActiveSortType,
    SearchParams,
    SortData,
    UseSortDataSelectorParams,
} from './types';

export const usePricingSelector = ({
    originPlaceId,
    destinationPlaceId,
}: {
    originPlaceId?: string;
    destinationPlaceId?: string;
}) => {
    const pricingSelector = (state: RootState) => pricingSelectors.selectDailyDepartMinimumPricing(
        state,
        originPlaceId,
        destinationPlaceId,
    );

    return useSelector(pricingSelector);
};

export const useSortDataSelector = ({ date, searchParams }: UseSortDataSelectorParams) => {
    const paramString = searchParams.direction === 'depart'
        ? serializeFilterParams({ ...searchParams, departDate: date })
        : serializeFilterParams({ ...searchParams, returnDate: date });

    const daySelector = (state: RootState): SortData => filterSelectors
        .selectSortOptions(state, paramString);

    return useSelector(daySelector);
};

export const useSortTypeSelector = (searchParams: SearchParams): ActiveSortType => {
    const sortTypeSelector = (state: RootState) => filterSelectors
        .selectActiveSortType(state, searchParams);

    return useSelector(sortTypeSelector);
};
